import React from 'react'

export default function VoteSettings() {

    return (
        <>
           <h1>Settings</h1>
        </>
    )
}